import { Metamodel } from '../base/model';
import { IModel } from '../base/annotation';
import { LinkedService } from '../linkedservice/linkedservice';

import { AzureKeyVault } from 'app/model/linkedservice/key-vault';
import { validateAKVLinkedserviceReference } from 'app/shared/utils/linkedservice-validation-util';
import { format } from 'app/shared/utils/string.util';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@Metamodel.model({
    name: adfModelTypeMap.mongoDb.linkedServiceType,
    display: [
        format(stringResources.ModelName_LinkedServiceTemplate, stringResources.MongoDb_DisplayText),
        format(stringResources.ModelName_LinkedServicesTemplate, stringResources.MongoDb_DisplayText)
    ]
})
export class NativeMongoDbLinkedService extends LinkedService {

    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.ModelName_ConnectionString
    })
    public connectionString: string;

    @Metamodel.attribute({
        display: stringResources.ModelName_DatabaseName
    })
    public databaseName: string;

    public enableAKV?: boolean = false;
    @Metamodel.attribute({
        constraint: {
            validator: validateAKVLinkedserviceReference
        }
    })
    public referedAKV?: AzureKeyVault;

    constructor(name?: string, description?: string) {
        super(name, description);
    }
}
